import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { sendFeedback } from './searchFeedback.api';
import styles from './feedback_box.module.scss';
import { Connect } from './FeedbackBoxContainer';
import { QueryParamsType } from '../../../state/reducers/queryParams.types';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';

type ButtonValues = 'YES' | 'NO' | 'PARTIALLY';

type Props = {
  originalQueryKey: QueryParamsType['originalQueryKey'];
} & UserContextType;

type State = {
  response: ButtonValues | null;
  comment: string;
  sent: boolean;
};

export class RawFeedbackBox extends React.Component<Props> {
  state: State = {
    response: null,
    comment: '',
    sent: false,
  };

  sendFeedback = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    try {
      const { originalQueryKey } = this.props;
      const { response, comment } = this.state;
      doctrineAnalytics('Search FeedbackFormSent', {
        answer: response,
      });
      if (response && originalQueryKey) {
        await sendFeedback({ response, comment, originalQueryKey });
        this.setState({ sent: true, response: null, comment: '' });
      }
    } catch (error) {
      throw error;
    }
  };

  onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;
    this.setState({ comment: value });
  };

  selectAnswer = (value: ButtonValues) => () => {
    this.setState({ response: value });
  };

  render() {
    const { response, comment, sent } = this.state;
    const { accessPremium } = this.props;

    if (!accessPremium) {
      return null;
    }

    return (
      <div className={styles.card}>
        <div className={styles.title}>
          {sent
            ? `Merci pour votre contribution.`
            : `Donnez votre avis sur le moteur de recherche.`}
        </div>
        {sent ? (
          'Vos retours nous aident à améliorer notre service.'
        ) : (
          <form onSubmit={this.sendFeedback}>
            <div>
              <label className={styles.label}>
                <FormattedMessage id="search/components/search-results/feedback-box/FeedbackBox.tsx/1" />
              </label>
              <div>
                <button
                  type="button"
                  className={classNames(
                    'button small',
                    styles.button,
                    response === 'YES' && styles.button_selected,
                    {
                      hollow: response !== 'YES',
                    },
                  )}
                  onClick={this.selectAnswer('YES')}
                >
                  <FormattedMessage id="search/components/search-results/feedback-box/FeedbackBox.tsx/2" />
                </button>

                <button
                  type="button"
                  className={classNames(
                    'button small',
                    styles.button,
                    response === 'NO' && styles.button_selected,
                    {
                      hollow: response !== 'NO',
                    },
                  )}
                  onClick={this.selectAnswer('NO')}
                >
                  <FormattedMessage id="search/components/search-results/feedback-box/FeedbackBox.tsx/3" />
                </button>
                <button
                  type="button"
                  className={classNames(
                    'button small',
                    styles.button,
                    response === 'PARTIALLY' && styles.button_selected,
                    {
                      hollow: response !== 'PARTIALLY',
                    },
                  )}
                  onClick={this.selectAnswer('PARTIALLY')}
                >
                  <FormattedMessage id="search/components/search-results/feedback-box/FeedbackBox.tsx/4" />
                </button>
              </div>
            </div>
            {response !== null && (
              <div>
                <label className={styles.label}>
                  {response === 'YES' &&
                    `Laissez-nous un commentaire sur l'objet de votre recherche et les éventuelles difficultés que vous avez rencontrées.`}
                  {response !== 'YES' &&
                    `Laissez-nous un commentaire sur l'objet de votre recherche et les difficultés que vous rencontrez.`}
                </label>
                <textarea
                  className={styles.textarea}
                  rows={3}
                  value={comment}
                  onChange={this.onChange}
                />
                <button
                  type="submit"
                  className={classNames('button small', styles.button)}
                >
                  <FormattedMessage id="search/components/search-results/feedback-box/FeedbackBox.tsx/5" />
                </button>
              </div>
            )}
          </form>
        )}
      </div>
    );
  }
}

export const FeedbackBox = withUser(Connect(RawFeedbackBox));
